import React, { useState } from 'react';
import './ManningModal.css';
import { fetchWithAuth } from './utils';
import { useEffect } from 'react';

interface ManningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (newManning: any) => void;
  onRefresh: () => void;
  regionCode: string | null;
  uniqueLeaders: string[];
  editingManning?: any;    
  isEditing?: boolean;    
}


const ManningModal: React.FC<ManningModalProps> = ({ isOpen, onClose, onSave, onRefresh, regionCode, uniqueLeaders, editingManning, isEditing}) => {
  const [officeList, setOfficeList] = useState<{ office_code: string; office_name: string }[]>([]);
  const [regions, setRegions] = useState<{ region_code: string; region_name: string }[]>([]); // <-- NEW
  const [customLeaderName, setCustomLeaderName] = useState("");

  const [error, setError] = useState(''); 
  const [formData, setFormData] = useState({
    company_code: 'DG',
    region_code: '',
    office_code: '',
    name: '',
    email: '',
    title: '',
    type: '',
    primary_practice: '',
    discipline: '',
    experience: '',
    current_market_sector: '',
    leader_name: '',
  });

  const [skills, setSkills] = useState<any[]>([]);
  const [showAddSkill, setShowAddSkill] = useState(false);
  const [newSkill, setNewSkill] = useState('');
  const [newSkillLevel, setNewSkillLevel] = useState('Intermediate');
  const [skillLoading, setSkillLoading] = useState(false);
  const [activeTab, setActiveTab] = useState<'manning' | 'skills' | 'resume'>('manning');
  const [isSaving, setIsSaving] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState('');
  const [resumeUrl, setResumeUrl] = useState<string | null>(null);
  const [resumeLoading, setResumeLoading] = useState(false);

  const [skillSuccess, setSkillSuccess] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  
useEffect(() => {
  const fetchSkills = async () => {
    if (!editingManning?.manning_info_id) return;

    try {
      const url = `https://manningserviceapp.azurewebsites.net/api/MainRoute?code=GUgZKUh3at7CoJZqYItK4T3zUXK_aJred4q-7EIwAkGMAzFuYSmcaQ==&action=get_manning_skills&manning_id=${editingManning.manning_info_id}`;

      const data = await fetchWithAuth(url);
      setSkills(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching skills:", err);
      setSkills([]);
    }
  };

  if (isOpen && isEditing) {
    fetchSkills();
  }
}, [isOpen, isEditing, editingManning]);

const handleAddSkill = async () => {
  if (!newSkill.trim()) return;

  try {
    setSkillLoading(true);
    setSkillSuccess('');

    const url = `https://manningserviceapp.azurewebsites.net/api/MainRoute?code=GUgZKUh3at7CoJZqYItK4T3zUXK_aJred4q-7EIwAkGMAzFuYSmcaQ==&action=add_new_skill`;

    await fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        manning_info_id: editingManning.manning_info_id,
        skill: newSkill,
        skill_level: newSkillLevel,
      }),
    });

    // 🔥 Refresh list
    setSkillSuccess('Skill added successfully ✅');
    setNewSkill('');
    setNewSkillLevel('Intermediate');

    // reload skills
    const refreshUrl = `https://manningserviceapp.azurewebsites.net/api/MainRoute?code=GUgZKUh3at7CoJZqYItK4T3zUXK_aJred4q-7EIwAkGMAzFuYSmcaQ==&action=get_manning_skills&manning_id=${editingManning.manning_info_id}`;
    const data = await fetchWithAuth(refreshUrl);
    setSkills(Array.isArray(data) ? data : []);

  } catch (err) {
    console.error("Error adding skill:", err);
  } finally {
    setSkillLoading(false);
  }
};

const [selectedSkillOption, setSelectedSkillOption] = useState<any>(null);
const skillOptions = [
  ...skills.map((s) => ({
    value: `${s.skill}|${s.skill_level}`,
    label: `${s.skill} (${s.skill_level})`,
  })),
  { value: "__add_new__", label: "+ Add New Skill" },
];

const handleSkillSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
  const value = e.target.value;

  if (value === "__add_new__") {
    setShowAddSkill(true);
    setSkillSuccess('');
    return;
  }

  const [skill, level] = value.split("|");

  handleAddSkillDirect(skill, level);
};

const handleAddSkillDirect = async (skill: string, level: string) => {
  try {
    const url = `https://manningserviceapp.azurewebsites.net/api/MainRoute?code=GUgZKUh3at7CoJZqYItK4T3zUXK_aJred4q-7EIwAkGMAzFuYSmcaQ==&action=add_new_skill`;

    await fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        manning_info_id: editingManning.manning_info_id,
        skill,
        skill_level: level,
      }),
    });

    // refresh skills
    const refreshUrl = `https://manningserviceapp.azurewebsites.net/api/MainRoute?code=GUgZKUh3at7CoJZqYItK4T3zUXK_aJred4q-7EIwAkGMAzFuYSmcaQ==&action=get_manning_skills&manning_id=${editingManning.manning_info_id}`;
    const data = await fetchWithAuth(refreshUrl);
    setSkills(Array.isArray(data) ? data : []);

  } catch (err) {
    console.error("Error adding skill:", err);
  }
};

const handleSave = async () => {
  setError('');
  setSaveSuccess('');
  setIsSaving(true);
  try {
    const { name, email, title, office_code, region_code, leader_name } = formData;

    // Determine final leader name before validation
    const finalLeaderName = leader_name === "Other" ? customLeaderName.trim() : leader_name;

    if (!name || !email || !title || !office_code || !region_code || !finalLeaderName) {
      setError('Please fill in all required fields.');
      setIsSaving(false);
      return;
    }

    if (!isValidEmail(email)) {
      setError('Please enter a valid email address.');
      setIsSaving(false);
      return;
    }

    // 👇 Build the payload using the final leader name
    const payload = { ...formData, leader_name: finalLeaderName };

    let url, result;
    if (isEditing && editingManning) {
      url = 'https://manningserviceapp.azurewebsites.net/api/MainRoute?code=GUgZKUh3at7CoJZqYItK4T3zUXK_aJred4q-7EIwAkGMAzFuYSmcaQ==&action=update_manning';
      result = await fetchWithAuth(url, {
        method: 'POST',
        body: JSON.stringify({ ...payload, manning_info_id: editingManning.manning_info_id }),
      });
    } else {
      url = 'https://manningserviceapp.azurewebsites.net/api/MainRoute?code=GUgZKUh3at7CoJZqYItK4T3zUXK_aJred4q-7EIwAkGMAzFuYSmcaQ==&action=add_manning';
      result = await fetchWithAuth(url, {
        method: 'POST',
        body: JSON.stringify(payload),
      });
    }

    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith("manning_")) {
        localStorage.removeItem(key);
      }
    });

    // (The rest of your populate_week_data logic stays the same)
    if (result?.status?.trim().toLowerCase() === 'success') {
      setSaveSuccess('Manning saved successfully ✅');
      if (!isEditing && result.manning_info_id !== undefined) {
        const manningId = result.manning_info_id;
        const currentMonth = new Date().getMonth() + 1;
        const currentYear = new Date().getFullYear();
        const nextYear = currentYear + 1;

        for (let month = currentMonth; month <= 12; month++) {
          const populateUrl = `https://manningserviceapp.azurewebsites.net/api/MainRoute?code=GUgZKUh3at7CoJZqYItK4T3zUXK_aJred4q-7EIwAkGMAzFuYSmcaQ==&action=populate_week_data&month=${month}&year=${currentYear}&manning_id=${manningId}`;
          fetchWithAuth(populateUrl).catch(err =>
            console.error(`Error populating data for ${month}/${currentYear}:`, err)
          );
        }

        for (let month = 1; month <= 12; month++) {
          const populateUrl = `https://manningserviceapp.azurewebsites.net/api/MainRoute?code=GUgZKUh3at7CoJZqYItK4T3zUXK_aJred4q-7EIwAkGMAzFuYSmcaQ==&action=populate_week_data&month=${month}&year=${nextYear}&manning_id=${manningId}`;
          fetchWithAuth(populateUrl).catch(err =>
            console.error(`Error populating data for ${month}/${nextYear}:`, err)
          );
        }
      }

      onSave({ ...payload, ...(isEditing && editingManning ? { manning_info_id: editingManning.manning_info_id } : {}) });
      onRefresh();
      onClose();
    } else {
      setError(result.message || 'Failed to save manning data.');
    }
  } catch (err) {
    console.error('Error saving manning:', err);
    setError('There was an error saving the manning data.');
  } finally {
    setIsSaving(false);
  }
};

    

  useEffect(() => {
    const region = regionCode; // from props
    const officeKey = `offices_${region}`;
    const offices = JSON.parse(localStorage.getItem(officeKey) || '[]');

    setFormData((prev) => ({ ...prev, region_code: region || '' }));
    setOfficeList(offices);
  }, [regionCode]);

const titles = [
  "Controls Engineer",
  "Controls Engineer II",
  "Controls Engineer III",
  "Controls Specialist",
  "Director",
  "Director of PM",
  "Instrumentation & Controls Engineer",
  "Instrumentation & Controls Engineer II",
  "Instrumentation & Controls Engineer III",
  "Instrumentation & Controls Designer",
  "Instrumentation & Controls Designer II",
  "Intern",
  "Manager, Control Systems Integration",
  "Manager, Information Solutions",
  "Manager, Instrumentation and Controls",
  "Network Engineer",
  "Partner",
  "Principal, Controls",
  "Principal, Software Engineering",
  "Process Engineer",
  "Process Engineer II",
  "Project Engineer",
  "Project Engineer II",
  "Project Manager",
  "Project Manager II",
  "Project Manager, Control Systems",
  "Project Manager, Electrical Engineering",
  "Software Engineer I",
  "Software Engineer II",
  "Software Engineer III",
  "Sr. Controls Engineer",
  "Sr. Designer, Instrumentation and Controls",
  "Sr. Manager, Instrumentation and Controls",
  "Sr. Engineer, Instrumentation and Controls",
  "Sr. Network Engineer",
  "Sr. Process Engineer",
  "Sr. Project Engineer",
  "Sr. Project Manager",
  "Sr. Software Engineer"
];


const primaryPracticeOptions = [
  "A/E Process",
  "CSI",
  "CSI-MEI",
  "IS"
];

const marketSectors = [
  "Beer",
  "Beverage Coffee & Tea",
  "Beverage Dairy",
  "Beverage Dried or Powered",
  "Beverage Juice",
  "Beverage Other",
  "Beverage Soft Drinks",
  "Beverage Sport",
  "Beverage Water",
  "Biotech",
  "Container Manufacturing Can",
  "Container Manufacturing Glass",
  "Container Manufacturing Plasti",
  "DNU Dairy",
  "Food Bakery",
  "Food Candy & Confectionary",
  "Food Cereal",
  "Food Dairy",
  "Food Grains, Ingr. Spices &Ag",
  "Food Meat",
  "Food Other",
  "Food Pet",
  "Food Pork",
  "Food Poultry",
  "Food Prepared Produce",
  "Food Sauce Dressing Condiments",
  "Food Seafood",
  "Food Snacks",
  "Ind.- Adv. Materials-Aerospace",
  "Ind.- Advanced Materials-Metal",
  "Ind.- Automotive",
  "Ind.- Building Automation",
  "Ind.- Chemical",
  "Ind.- Chemical-Agriculture",
  "Ind.- Chemical-Basic",
  "Ind.- Chemical Consumer",
  "Ind.- Data Centers",
  "Ind.- Energy-Oil & Gas",
  "Ind.- Energy-Renewables",
  "Ind.- Hi Tech, Advance Tech",
  "Ind.- Oil DNU",
  "Ind.- Paper - Corrugate",
  "Ind.- Pulp & Paper",
  "Ind.- Pulp & Paper Build Prod",
  "Ind.- Water/Waste Water",
  "Intercompany",
  "Life Sciences Other",
  "Medical Devices",
  "Nutraceutical & Dietary Supp.",
  "Other Industrial",
  "Personal Care & Cosmetic",
  "Pharmaceuticals",
  "Semiconductor",
  "Unknown",
  "Utilities",
  "Wine & Distilled Spirits",
  "iND.- Chemical-Specialty"
];

const disciplineOptions = [
  "Architect",
  "Architectural Design/BIM",
  "Civil",
  "Construction",
  "Design/Drafting",
  "Electrical",
  "Leadership",
  "Mechanical",
  "Process",
  "Project Management",
  "Refrigeration",
  "Structural",
  "Structural (Drafting)"
];


useEffect(() => {
  if (isEditing && editingManning) {
    setFormData({
      company_code: editingManning.company_code ?? 'DG',
      region_code: editingManning.region_code ?? (regionCode || ''),
      office_code: editingManning.office_code ?? '',
      name: editingManning.name ?? '',
      email: editingManning.email ?? '',
      title: editingManning.title ?? '',
      type: editingManning.type ?? '',
      primary_practice: editingManning.primary_practice ?? '',
      discipline: editingManning.discipline ?? '',
      experience: editingManning.experience ?? '',
      current_market_sector: editingManning.current_market_sector ?? '',
      leader_name: editingManning.leader_name ?? '',
    });
  } else if (!isEditing) {
    // Clear the form for Add
    setFormData({
      company_code: 'DG',
      region_code: regionCode || '',
      office_code: '',
      name: '',
      email: '',
      title: '',
      type: '',
      primary_practice: '',
      discipline: '',
      experience: '',
      current_market_sector: '',
      leader_name: '',
    });
  }
}, [isEditing, editingManning, regionCode, isOpen]);

  // Fetch regions when the component mounts
  useEffect(() => {
    const fetchRegions = async () => {
      const cachedRegions = getCachedData('regions_new');
      if (cachedRegions) {
        setRegions(cachedRegions);
        return;
      }

      try {
        const url = `https://manningserviceapp.azurewebsites.net/api/MainRoute?code=GUgZKUh3at7CoJZqYItK4T3zUXK_aJred4q-7EIwAkGMAzFuYSmcaQ==&action=get_regions&company_code=DG`;
        const data = await fetchWithAuth(url);

        setRegions(data);
        setCachedData('regions_new', data); // Cache the data
      } catch (error) {
        console.error('Error fetching regions:', error);
      }
    };

    fetchRegions();
  }, []);

  const getCachedData = (key: string) => {
    const cached = localStorage.getItem(key);
    if (cached && cached !== "undefined") {
      try {
        return JSON.parse(cached);
      } catch (e) {
        console.error(`Error parsing cached data for key: ${key}`, e);
      }
    }
    return null;
  };


  const setCachedData = (key: string, data: any) => {
    localStorage.setItem(key, JSON.stringify(data));
  };

useEffect(() => {
  if (isEditing && skills.length === 0) {
    setShowAddSkill(true);
  }
}, [skills, isEditing]);


useEffect(() => {
  if (skillSuccess) {
    const timer = setTimeout(() => {
      setSkillSuccess('');
    }, 5000); // 5 seconds

    return () => clearTimeout(timer); // cleanup
  }
}, [skillSuccess]);

const isValidEmail = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}> ✕ </button>
        <h2>
        {isEditing && editingManning?.name
          ? `${editingManning.name} - Profile`
          : 'Add New Manning'}
        </h2>
<div className="tab-container">
  <div className="tab-header">
    <div
      className={`tab-item ${activeTab === 'manning' ? 'active' : ''}`}
      onClick={() => setActiveTab('manning')}
    >
      Edit Manning
    </div>

    <div
      className={`tab-item ${activeTab === 'skills' ? 'active' : ''}`}
      onClick={() => setActiveTab('skills')}
    >
      Manage Skills
    </div>

    <div
      className={`tab-item ${activeTab === 'resume' ? 'active' : ''}`}
      onClick={() => setActiveTab('resume')}
    >
      Resume
    </div>
  </div>
</div>
        {activeTab === 'manning' && (
        <>
        <div className="form-grid">

          <div className="form-group">
            <label>Region Code</label>
            {regionCode === 'NATIONAL' ? (
              <select
                name="region_code"
                value={formData.region_code}
                onChange={handleChange}
                required
              >
                <option value="">Select Region</option>
                {regions.map((region, idx) => (
                  <option key={idx} value={region.region_code}>
                    {region.region_name || region.region_code}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type="text"
                name="region_code"
                value={formData.region_code}
                onChange={handleChange}
                readOnly
              />
            )}
          </div>


          <div className="form-group">
            <label>Office Code</label>
            <select
              name="office_code"
              value={formData.office_code}
              onChange={handleChange}
              required
            >
              <option value="">Select Office</option>
              {officeList.map((office) => (
                <option key={office.office_code} value={office.office_code}>
                  {office.office_name}
                </option>
              ))}

            </select>
          </div>

          <div className="form-group">
            <label>Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} required/>
          </div>
          <div className="form-group">
            <label>Email</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required/>
          </div>
          <div className="form-group">
            <label>Title</label>
            <select name="title" value={formData.title} onChange={handleChange} required>
              <option value="">Select Title</option>
              {titles.map((title, index) => (
                <option key={index} value={title}>
                  {title}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Type</label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              style={{ width: '100%' }}
            >
              <option value="">Select Type</option>
              <option value="Regular">Regular</option>
              <option value="Fixed (DOP)">Fixed (DOP)</option>
            </select>
          </div>

          <div className="form-group">
            <label>Primary Practice</label>
            <select name="primary_practice" value={formData.primary_practice} onChange={handleChange}>
              <option value="">Select Primary Practice</option>
              {primaryPracticeOptions.map((practice, index) => (
                <option key={index} value={practice}>
                  {practice}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Discipline</label>
            <select
              name="discipline"
              value={formData.discipline}
              onChange={handleChange}
              style={{ width: '100%' }}
            >
              <option value="">Select Discipline</option>
              {disciplineOptions.map((discipline, index) => (
                <option key={index} value={discipline}>
                  {discipline}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Experience</label>
            <select
              name="experience"
              value={formData.experience}
              onChange={handleChange}
              style={{ width: '100%' }} // You can adjust width here
            >
              <option value="">Select Experience</option>
              <option value="0-2 yrs">0-2 yrs</option>
              <option value="3 - 5yrs">3 - 5yrs</option>
              <option value="5-7 yrs">5-7 yrs</option>
              <option value="8-10yrs">8-10yrs</option>
              <option value="10-15 yrs">10-15 yrs</option>
              <option value="15+ yrs">15+ yrs</option>
            </select>
          </div>

          <div className="form-group">
            <label>Leader Name</label>
            <select
              name="leader_name"
              value={formData.leader_name}
              onChange={handleChange}
              required
            >
              <option value="">Select Leader</option>
              {uniqueLeaders.map((leader, idx) => (
                <option key={idx} value={leader}>{leader}</option>
              ))}
              <option value="Other">Other (Enter manually)</option>
            </select>

            {formData.leader_name === "Other" && (
              <input
                type="text"
                placeholder="Enter Leader Name"
                value={customLeaderName}
                onChange={(e) => setCustomLeaderName(e.target.value)}
                style={{ marginTop: "8px" }}
                required
              />
            )}
          </div>
        </div>

        <div className="modal-actions">
          <button className="save-button" onClick={handleSave}>
            {isSaving ? 'Processing...' : 'Save'}
          </button>
          <button className="save-button" onClick={onClose}>
            Close
          </button>
        </div>

        {error && (
          <div style={{ color: 'red', marginBottom: '10px' }}>
            {error}
          </div>
        )}

        {saveSuccess && (
          <div style={{ color: 'green', marginTop: '10px' }}>
            {saveSuccess}
          </div>
        )}
  </>
)}
        {/* Add Skill Section */}
        {activeTab === 'skills' && (
<div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>

  {/* Header */}
  <div style={{ fontWeight: 'bold' }}>Current Skills</div>

  {/* Skill Dropdown */}
  <select
    value=""
    onChange={handleSkillSelect}
    style={{ height: '35px', width: '220px' }}
  >
    {skills.map((s, idx) => (
      <option key={idx} value={`${s.skill}|${s.skill_level}`}>
        {s.skill} ({s.skill_level})
      </option>
    ))}

    <option value="__add_new__">+ Add New Skill</option>
  </select>

  {/* Add New Skill UI (only when selected) */}
{showAddSkill && (
  <div className="skill-modal">

    {/* Header */}
    <div className="skill-modal-header">
      <div className="skill-modal-title">Add New Skill</div>


    </div>

    {/* Inputs */}
    <div className="skill-modal-body">
      <input
        type="text"
        placeholder="Enter new skill"
        value={newSkill}
        onChange={(e) => setNewSkill(e.target.value)}
        className="skill-input"
      />

      <select
        value={newSkillLevel}
        onChange={(e) => setNewSkillLevel(e.target.value)}
        className="skill-select"
      >
        <option value="Beginner">Beginner</option>
        <option value="Intermediate">Intermediate</option>
        <option value="Advanced">Advanced</option>
        <option value="Expert">Expert</option>
        <option value="SME">SME</option>
      </select>

      <button
        className="save-button"
        onClick={handleAddSkill}
        disabled={skillLoading}
      >
        {skillLoading ? 'Saving...' : 'Add'}
      </button>
    </div>

  </div>
)}

  {skillSuccess && (
  <div style={{ color: 'green' }}>
    {skillSuccess}
  </div>
  )}
</div>

)}

{activeTab === 'resume' && (
  <div>
    {editingManning?.resume_url ? (
      <button className="save-button" onClick={() => window.open(editingManning.resume_url, '_blank')}>
        View Resume
      </button>
    ) : (
      <div>
        <div style={{ marginBottom: '10px' }}>
          No resume available.
        </div>

        <div style={{ marginBottom: '10px' }}>
          Follow the steps below to set up your resume:
          <br />
          <ul>
            <li>
              Click the link below to go to the SharePoint Resume Library:
              <a
                href="https://bw1.sharepoint.com/sites/DGKnowledgeManagement/Resumes/Forms/Active%20Resumes.aspx?viewid=3aeafd84%2Df76a%2D4e56%2D99f0%2D4642e8d426e7"
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'block', marginTop: '5px', marginBottom: '10px', color: '#007bff' }}
              >
                Resume Library
              </a>
            </li>
            <li>Search your resume and copy the resume URL.</li>
            <li>Paste the resume URL in the text field below and click Save.</li>
            <li>
              Once saved, you should see a "View Resume" button to view your resume.
            </li>
          </ul>
        </div>



        <input
          type="text"
          placeholder="Paste Resume URL here"
          value={resumeUrl || ''}
          onChange={(e) => setResumeUrl(e.target.value)}
          style={{ width: '100%', marginBottom: '10px' }}
        />

        <button
          className="save-button"
          onClick={async () => {
            try {
              const url = `https://manningserviceapp.azurewebsites.net/api/MainRoute?code=GUgZKUh3at7CoJZqYItK4T3zUXK_aJred4q-7EIwAkGMAzFuYSmcaQ==&action=update_resume_url`;

              await fetchWithAuth(url, {
                method: 'POST',
                body: JSON.stringify({
                  manning_info_id: editingManning.manning_info_id,
                  resume_url: resumeUrl,
                }),
              });

              editingManning.resume_url = resumeUrl;  
              setSaveSuccess('Resume URL saved successfully ✅');
              setActiveTab('manning'); 
              setActiveTab('resume');
              onRefresh();
            } catch (err) {
              console.error("Error saving resume URL:", err);
              setError('Failed to save resume URL');
            }
          }}
        >
          Save
        </button>
      </div>
    )}
  </div>
)}
      </div>
    </div>
  );
};

export default ManningModal;
